module.exports = __webpack_public_path__ + "static/media/pill.280cdc05.svg";